import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { crc32 } from 'crc'
import ElementLocale from 'element-ui/lib/locale'
Vue.use(VueI18n);

import en from './json/en';
import zh_CN from './json/zh_CN';
import vi from './json/vi';
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import viLocale from 'element-ui/lib/locale/lang/vi'
/*---------使用语言包-----------*/ 
let langs = 'zh_CN'
langs = window.locale || 'zh_CN'

const i18n = new VueI18n({
  locale: langs, // 语言标识 
  silentTranslationWarn: true,
  messages: { 
    zh_CN: {
      ...zhLocale,
      ...zh_CN
    },//中文简体
    vi: {
      ...viLocale,
      ...vi
    },
    en: {
      ...enLocale,
      ...en,
    }
  },
//   silentTranslationWarn: true,
})

ElementLocale.i18n((key, value) => i18n.t(key, value))
console.log(i18n, 'i18n');
export function lang(key, o) {
  // let hashKey =`k${crc32(key).toString(16)}`
  let hashKey = key;//已经在外部用 crc.js 计算过了
  let words = i18n.t(hashKey, o)
  if (words === hashKey) {
    words = key
    // console.log(key, '-没翻译')
  }
  // 由于vue-i18n不支持有插入值,不传空时，不显示字符串中的{xxx}，所以这里处理下输出
  try {
    const matchList = words.match(/\{[^\}]+\}/g)
    if (matchList && matchList.length) {
      matchList.forEach(el => {
        words = words.replace(el, o !== undefined ? o[`${el.replace(/[^a-zA-Z]/g, '')}`] : '') 
      })
    }
  } catch (error) {
    console.log(error);
  }
  
  return words
}


export default i18n;